import { Link } from "@/components/Link";
import styled from "styled-components";

export interface HeaderContainerProps {
  border?: boolean;
}

export const HeaderContainer = styled.header.withConfig({
  shouldForwardProp: (prop) => !["border"].includes(prop),
})<HeaderContainerProps>`
  min-height: 64px;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacers.M};
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacers.L};
  padding-left: 0;
  border-bottom: ${(props) => (props.border ? `2px solid ${props.theme.colors.stroke.lighterGrey}` : "none")};

  @media (${({ theme }) => theme.screens.tablet}) {
    border-bottom: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
  }
`;

export const NavList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.spacers.L};
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  column-gap: ${({ theme }) => theme.spacers.M};
  padding-left: ${({ theme }) => theme.spacers.M};
`;

export const NavItem = styled.li`
  display: flex;
  align-items: center;
  position: relative;
`;

export const CartItemCounter = styled.span`
  background-color: ${({ theme }) => theme.colors.background.baseExciteRed};
  ${({ theme }) => theme.typography.TinyParagraphBold};
  color: ${({ theme }) => theme.colors.text.white};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  width: ${({ theme }) => theme.spacers.L};
  height: ${({ theme }) => theme.spacers.L};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 1px;
`;

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${({ theme }) => theme.spacers["3XL"]};
  height: ${({ theme }) => theme.spacers["3XL"]};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  transition: background-color 0.2s ease-in-out;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.stroke.lighterGrey};
  }
`;
